import { useAdminCheck } from '@/hooks/useAdminCheck';
import { useUserRoles } from '@/hooks/useUserRoles';

const ALLOWED_ROLES = ['ROLE_PROJECT_MANAGER', 'ROLE_TEAM_LEAD', 'ROLE_EDITOR'];

/**
 * Permission gate for editing lifecycle_stage_override.
 * FE-only check; RLS trigger enforce_lifecycle_override_role is source of truth.
 */
export const useCanOverrideLifecycle = (): boolean => {
  const { isAdmin } = useAdminCheck();
  const { data: roles } = useUserRoles();
  return isAdmin || (roles ?? []).some((r) => ALLOWED_ROLES.includes(r.role_code));
};
